export function materialClassificationsReducer(
    state = { scarpItem: [], scrapLoading: false, loading: false, organizationScrap: [] },
    { type, payload }
) {
    switch (type) {
        case "SHOW_SCRAP_ITEM":
            return { ...state, loading: true };
        case "CANNOT_SCRAP_ITEM":
            return { ...state, loading: false };
        case "UPDATE_SCARP_ITEM_LOADING":
            return { ...state, scrapLoading: true };
        case "UPDATE_SCARP_ITEM_ERROR":
            return { ...state, scrapLoading: false };
        case "UPDATE_SCARP_ITEM_SUCCESS":
            return { ...state, scrapLoading: false };
        case "MY_ORGANIZATION_SCRAP_SUCCESS":
            return { ...state, organizationScrap: payload };
        case "GET_SCRAP_ITEMS":
            return { ...state, scarpItem: payload, loading: false };
        default:
            return state;
    }
}